import Carousel from 'react-bootstrap/Carousel';

import back from "statics/back.png";

function CarouselAd() {
  return (
    <Carousel>
      <Carousel.Item>
        <img src={back} style={{height: '360px', width: '100%'}} />
        <Carousel.Caption>
          <h3>First slide label</h3>
          <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img src={back} style={{height: '360px', width: '100%'}} />
        <Carousel.Caption>
          <h3>Second slide label</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default CarouselAd;